import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "owner-picker" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 1,
  class: "tag-chips"
}
const _hoisted_4 = ["aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.available.length)
      ? (_openBlock(), _createElementBlock("select", {
          key: 0,
          value: '',
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add($event)))
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("option", { value: "" }, "Add a person…", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available, (u) => {
            return (_openBlock(), _createElementBlock("option", {
              key: u.UserID,
              value: u.UserID
            }, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName), 9, _hoisted_2))
          }), 128))
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.selected.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected, (u) => {
            return (_openBlock(), _createElementBlock("span", {
              key: u.UserID,
              class: "tag-chip"
            }, [
              _createTextVNode(_toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "tag-chip-x",
                "aria-label": 'Remove ' + u.FirstName + ' ' + u.LastName,
                title: "Remove",
                onClick: ($event: any) => (_ctx.remove(u.UserID))
              }, [
                _createVNode(_component_svg_icon, { icon: "x" })
              ], 8, _hoisted_4)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}